export const screenCaptureCompletion = {
  celebrateCompletion() {
    this.showCompletionDialog()
    this.showCompletionNotification()
    this.flashTabTitle()
    this.playChime()
    if (this.validationWindow && !this.validationWindow.closed) {
      try {
        this.validationWindow.close()
      } catch {
        // The opener may not have permission to close the validation tab.
      }
    }
  },

  showCompletionNotification() {
    if (!this.wizardModeValue || !document.hidden || !("Notification" in window) || Notification.permission !== "granted") return

    try {
      const notification = new Notification(this.completionNotificationTitleValue, {
        body: this.completionNotificationBodyValue,
        tag: "status-match-verification-complete",
        renotify: true
      })
      notification.onclick = () => {
        window.focus()
        notification.close()
      }
    } catch {
      // Notifications remain best-effort after permission is granted.
    }
  },

  showCompletionDialog() {
    if (!this.hasCompletionDialogTarget || this.completionDialogTarget.open) return

    if (typeof this.completionDialogTarget.showModal === "function") {
      this.completionDialogTarget.showModal()
    } else {
      this.completionDialogTarget.setAttribute("open", "")
    }
  },

  continueAfterCompletion(event) {
    if (event) event.preventDefault()
    if (this.hasCompletionDialogTarget) this.completionDialogTarget.close()
    this.dispatch("complete", { bubbles: true })
  },

  keepCompletionDialogOpen(event) {
    event.preventDefault()
  },

  flashTabTitle() {
    if (typeof document === "undefined") return
    const original = document.title
    const messages = [this.t("verified_title", "✓ Verified — back to Stat Sync"), original]
    let index = 0
    const swap = () => {
      document.title = messages[index % messages.length]
      index += 1
    }
    swap()
    const timer = setInterval(swap, 1100)
    setTimeout(() => {
      clearInterval(timer)
      document.title = original
    }, 8000)
  },

  playChime() {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext
      if (!AudioContext) return
      const context = new AudioContext()
      const now = context.currentTime
      ;[
        { frequency: 660, time: 0, duration: 0.18 },
        { frequency: 880, time: 0.16, duration: 0.22 }
      ].forEach(({ frequency, time, duration }) => {
        const oscillator = context.createOscillator()
        const gain = context.createGain()
        oscillator.type = "sine"
        oscillator.frequency.value = frequency
        gain.gain.setValueAtTime(0.0001, now + time)
        gain.gain.exponentialRampToValueAtTime(0.18, now + time + 0.02)
        gain.gain.exponentialRampToValueAtTime(0.0001, now + time + duration)
        oscillator.connect(gain).connect(context.destination)
        oscillator.start(now + time)
        oscillator.stop(now + time + duration + 0.05)
      })
    } catch {
      // Audio is best-effort.
    }
  }
}
